import { useScrollAnimation, useStaggerAnimation } from '../../../hooks/useScrollAnimation';

export default function Problem() {
  const problems = [
    { icon: 'ri-money-dollar-circle-line', title: 'Pagando Mais do que Deveria', description: 'Empresas e pessoas físicas pagam até 40% a mais em seguros por falta de análise técnica e negociação profissional.' },
    { icon: 'ri-file-damage-line', title: 'Coberturas Inadequadas', description: 'Contratos mal estruturados deixam brechas que podem custar milhões em caso de sinistro.' },
    { icon: 'ri-time-line', title: 'Perda de Tempo e Dinheiro', description: 'Gestão amadora de seguros consome recursos internos e gera retrabalho constante.' },
    { icon: 'ri-alert-line', title: 'Riscos Não Identificados', description: 'Sem diagnóstico especializado, sua empresa fica exposta a riscos que poderiam ser evitados.' }
  ];

  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: gridRef, visibleItems } = useStaggerAnimation(problems.length);
  const { ref: ctaRef, isVisible: ctaVisible } = useScrollAnimation();

  return (
    <section className="py-16 sm:py-20 lg:py-28 bg-gradient-to-br from-petrol-50 to-white" aria-labelledby="problem-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className={`text-center mb-12 sm:mb-16 transition-all duration-700 ease-out ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div className="inline-flex items-center gap-2 bg-action-orange-100 px-4 py-2 rounded-full mb-4 sm:mb-6" aria-hidden="true">
            <i className="ri-error-warning-line text-action-orange-700 text-base sm:text-lg"></i>
            <span className="text-action-orange-800 font-bold text-xs sm:text-sm uppercase tracking-wide">O Problema</span>
          </div>
          <h2 id="problem-heading" className="text-3xl sm:text-4xl lg:text-5xl font-bold text-petrol-900 mb-4 sm:mb-6 px-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Por Que Contratar Seguros Sem Estratégia{' '}
            <span className="text-action-orange-600">Custa Caro</span>
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-petrol-800 max-w-3xl mx-auto leading-relaxed px-4">
            A maioria das empresas e pessoas físicas contrata seguros de forma amadora, sem análise técnica, sem negociação e sem gestão estratégica. O resultado? <strong className="text-petrol-900">Prejuízo financeiro e exposição a riscos desnecessários.</strong>
          </p>
        </div>

        <div ref={gridRef as React.RefObject<HTMLDivElement>} className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 mb-12 sm:mb-16">
          {problems.map((problem, index) => (
            <article
              key={index}
              className={`bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-2xl border border-petrol-100 hover:border-action-orange-300 group transition-all duration-700 ease-out ${visibleItems[index] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-action-orange-500 to-action-orange-600 rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform" aria-hidden="true">
                <i className={`${problem.icon} text-2xl sm:text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-petrol-900 mb-3 sm:mb-4">{problem.title}</h3>
              <p className="text-sm sm:text-base text-petrol-800 leading-relaxed">{problem.description}</p>
            </article>
          ))}
        </div>

        <div
          ref={ctaRef as React.RefObject<HTMLDivElement>}
          className={`bg-gradient-to-r from-petrol-900 to-petrol-700 rounded-xl sm:rounded-2xl p-6 sm:p-10 lg:p-12 text-center shadow-2xl transition-all duration-700 ease-out ${ctaVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-8 scale-95'}`}
        >
          <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-3 sm:mb-4 px-2" style={{ fontFamily: "'Playfair Display', serif" }}>
            Você Não Precisa Aceitar Isso
          </h3>
          <p className="text-base sm:text-lg lg:text-xl text-gray-100 mb-6 sm:mb-8 max-w-2xl mx-auto px-4">
            A IBX Brasil profissionaliza sua contratação de seguros com análise técnica, negociação estratégica e gestão completa.
          </p>
          <a
            href="#solucao"
            className="inline-flex items-center justify-center gap-2 sm:gap-3 bg-action-orange-500 text-white px-6 sm:px-8 py-4 sm:py-5 rounded-xl text-base sm:text-lg font-bold hover:bg-action-orange-600 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto"
            aria-label="Conhecer a solução da IBX Brasil"
          >
            <i className="ri-lightbulb-flash-line text-xl sm:text-2xl" aria-hidden="true"></i>
            Conhecer a Solução
          </a>
        </div>

      </div>
    </section>
  );
}
